module.exports = __webpack_public_path__ + "static/media/RecomendaMorroSP.58dc7d0f.jpg";